import {
    AddressResMapType,
    BasicClientInfoType,
    CreateAddress,
    SearchAccountContactMapResType,
    SearchAccountType,
    SearchAddressMapResType,
    SearchErpAccountResMapType,
    SearchTierInfoResType,
    Shipment,
    SystemUserMapType,
} from "../../pages/customer/correspondent/detail/interface";
import {DefaultResType, ErrorType, ResponseResType, SuccessType,} from "../../types/common/response";
import {baseApi} from "../../util/axiosConfig";
import {
    CreateCorrespondentInterface
} from "../../pages/customer/correspondent/create/interface/CreateCorrespondentInterface";
import {BasicSearchType, CommonSelectType, DeleteFileType, DownloadFileType,} from "../../types/common/basic";
import {AccountSearchInterface} from "../../pages/customer/correspondent/list/interface/searchInterface";

/**
 * 거래처 관리
 */
const url = "api/customer/account/";

/**
 * 거래처 검색
 * @param data
 * @returns
 */
export async function readAccountlistApi(data: any): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "read_account_list", data);
    } catch (err: any) {
        return err?.response;
    }
}

/**
 * 거래처 사업자등록증 업로드
 * @param formData
 * @returns
 */
export async function createAccountBusinessFile(
    formData: FormData
): Promise<DefaultResType | ErrorType> {
    const response = await baseApi.post(
        url + "create_account_business_file",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response?.data;
}

/**
 * CRM 최초 동기화
 * @param data
 * @returns
 */
export async function syncAccountFromDynamics(
    data: any
): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "sync_accounts_from_dynamics", data);
    } catch (err: any) {
        return err?.response;
    }
}

/**
 * 거래처 기본정보
 * @param id string
 * @returns
 */
export async function readAccountBasicInfoApi(
    id: string
): Promise<ResponseResType<BasicClientInfoType> | ErrorType> {
    const response = await baseApi.post(url + "read_account_basic_info", {
        id: id,
    });

    return response.data;
}

/**
 * 업체 관계 selectbox
 * @returns
 */
export async function readCustomerTypeSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_customer_type_select_box");
    return response.data;
}

/**
 * 수금 방법 selectbox
 * @returns
 */
export async function readBillSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_bill_select_box");
    return response.data;
}

/**
 * 소속 분류 selectbox
 * @returns
 */
export async function readCustomerCategorySelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(
        url + "read_customer_category_select_box"
    );
    return response.data;
}

/**
 * 산업 구분 selectbox
 * @returns
 */
export async function readIndustrySelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_industry_select_box");
    return response.data;
}

/**
 * 소재지 selectbox
 * @returns
 */
export async function readLocationSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_location_select_box");
    return response.data;
}

/**
 * 수금 예정월 selectbox
 * @returns
 */
export async function readReceiptTypeSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_receipt_type_select_box");
    return response.data;
}

/**
 * application select box
 * @returns
 */
export async function readApplicationSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_application_select_box");
    return response.data;
}

/**
 * 거래처 정보 수정
 */
export async function updateAccountInfoApi(
    data: BasicClientInfoType
): Promise<SuccessType | ErrorType> {
    const response = await baseApi.post(url + "update_account_info", data);

    return response.data;
}

/**
 * 거래처 출하 정보
 * @param data SearchAccountReqType
 * @returns  SearchAccountType
 */
export async function readAccountShipmentInfoApi(
    data: CreateCorrespondentInterface
): Promise<ResponseResType<SearchAccountType> | ErrorType> {
    const response = await baseApi.post(url + "read_account_shipment_info", data);
    return response.data;
}

/**
 * 환율 지정 조건 1 select box
 * @returns
 */
export async function readExchangeType1SelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_exchange_type1_select_box");
    return response?.data;
}

/**
 * 환율 지정 조건 2 select box
 * @returns
 */
export async function readExchangeType2SelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_exchange_type2_select_box");
    return response?.data;
}

/**
 * 환율 지정 조건 3 select box
 * @returns
 */
export async function readExchangeType3SelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_exchange_type3_select_box");
    return response?.data;
}

/**
 * 환율 단위 select box
 * @returns
 */
export async function readExchangeRateUnitSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_exchange_rate_unit_select_box");
    return response?.data;
}

/**
 * 환율 단위 select box
 * @returns
 */
export async function readWonUnitSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_won_unit_select_box");
    return response?.data;
}

/**
 * 수주유형 select box
 * @returns
 */
export async function readOrderTypeSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_order_type_select_box");
    return response?.data;
}

/**
 * vat 구분 select box
 * @returns
 */
export async function readVatSelectBoxApi(): Promise<
    ResponseResType<CommonSelectType[]> | ErrorType
> {
    const response = await baseApi.post(url + "read_vat_info_select_box");
    return response?.data;
}

/**
 * 거래처 연락처 검색
 */
export async function readAccountContactListApi(
    data: BasicSearchType & { accountId: string }
): Promise<ResponseResType<SearchAccountContactMapResType> | ErrorType> {
    const response = await baseApi.post(url + "read_account_contact_list", data);
    return response?.data;
}

/**
 * 거래처 주소 검색
 * @param data
 * @returns
 */
export async function readAccountAddressListApi(
    data: BasicSearchType & { accountId: string }
): Promise<ResponseResType<SearchAddressMapResType> | ErrorType> {
    const response = await baseApi.post(url + "read_account_address_list", data);
    return response?.data;
}

/**
 * 거래처 티어 정보
 * @param data
 * @returns
 */
export async function readAccountTierInfoApi(
    data: CreateCorrespondentInterface
): Promise<ResponseResType<SearchTierInfoResType> | ErrorType> {
    const response = await baseApi.post(url + "read_account_tier_info", data);
    return response?.data;
}

/**
 * ERP 거래처 검색
 * @param data
 * @returns
 */
export async function readErpAccountListApi(
    data: BasicSearchType
): Promise<ResponseResType<SearchErpAccountResMapType> | ErrorType> {
    const response = await baseApi.post(url + "read_erp_account_list", data);
    return response?.data;
}

/**
 * 출하 정보 저장
 * @param data
 * @returns
 */
export async function saveAccountShipmentInfoApi(
    data: SearchAccountType
): Promise<DefaultResType | ErrorType> {
    const response = await baseApi.post(url + "save_account_shipment_info", data);
    return response?.data;
}

/**
 * 주소탭 검색
 * @param data
 * @returns
 */
export async function readAddressListApi(
    data: BasicSearchType
): Promise<ResponseResType<AddressResMapType> | ErrorType> {
    const response = await baseApi.post(url + "read_address_list", data);
    return response?.data;
}

/**
 * 거래처 파일 다운로드
 * @param data
 * @returns
 */
export async function downloadAccountFileApi(
    data: DownloadFileType
): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "download_account_file", data, {
        responseType: "blob",
    });
    return response.data;
}

/**
 * 거래처 파일 삭제
 * @param data
 * @returns
 */
export async function deleteAccountBusinessFile(
    data: DeleteFileType
): Promise<DefaultResType | ErrorType> {
    const response = await baseApi.post(
        url + "delete_account_business_file",
        data
    );
    return response.data;
}

/**
 * 시스템 사용자 검색
 */
export async function readSystemUserListApi(
    data: BasicSearchType
): Promise<ResponseResType<SystemUserMapType> | ErrorType> {
    const response = await baseApi.post(url + "read_system_user_list", data);
    return response?.data;
}

/**
 * 거래처 티어 파일 등록
 */
export async function createAccountTierFileApi(
    formData: FormData
): Promise<DefaultResType | ErrorType> {
    const response = await baseApi.post(
        url + "create_account_tier_file",
        formData,
        {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        }
    );
    return response?.data;
}

/**
 * 거래처 티어 파일 삭제
 * @param data
 * @returns
 */
export async function deleteAccountTierFile(
    data: DeleteFileType
): Promise<DefaultResType | ErrorType> {
    const response = await baseApi.post(url + "delete_account_tier_file", data);
    return response.data;
}

/**
 * 이전결제건
 * @param data
 * @returns
 */
export async function readAccountBeforePaymentListApi(
    data: BasicSearchType & { newLEnduserValue: string }
): Promise<
    ResponseResType<{ list: Shipment[]; totalCount: number }> | ErrorType
> {
    const response = await baseApi.post(
        url + "read_account_before_payment_list",
        data
    );

    return response.data;
}

export async function saveAccountAddressInfo(data: CreateAddress): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "save_account_address_info", data);
    } catch (err: any) {
        return err?.response;
    }
}

export async function exportAccountExcelApi(
    data: AccountSearchInterface
): Promise<Blob | ArrayBuffer | Uint8Array | string | ErrorType> {
    const response = await baseApi.post(url + "export_account_excel", data, {
        responseType: "blob",
    });

    return response?.data;
}

export async function deleteAccountAddressInfo(data: { id: string }[]): Promise<DefaultResType> {
    try {
        return await baseApi.post(url + "delete_account_address_info", data);
    } catch (err: any) {
        return err?.response;
    }
}
